import React, { useEffect, useState } from 'react'
import ContentHeader from '../Layout/ContentHeader'
import LayoutTable from '../Global/LayoutTable'
import { useMutation, useQuery } from '@apollo/client'
import { DELETE_GROUP, GET_ALL_REPORT_GROUPS_BY } from '../../graphql/Catalog/ReportGroups/reportGroups'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'
import { GET_ALL_GROUPS_CATEGORIES } from '../../graphql/Catalog/ReportGroups/reportCategories'

const ReportCategories = () => {
    //HOOKS:
    const { showLoading, hideLoading } = useLoading()

    //STATES:
    const [dataTable, setDataToTable] = useState([])
    const [total, setTotal] = useState(0)
    const [pagePagination, setPagePagination] = useState({
        searchQuery: null,
        limit: 10,
        offset: 0,
    })

    //MUTATIONS:
    const [deleteItem] = useMutation(DELETE_GROUP, {
        refetchQueries: [
            {
                query: GET_ALL_GROUPS_CATEGORIES,
                variables: {
                    offset: 0,
                    limit: 10,
                    searchQuery: null,
                },
            },
        ],
    })

    //QUERYS:
    const data = useQuery(GET_ALL_GROUPS_CATEGORIES, {
        variables: { ...pagePagination },
        fetchPolicy: 'no-cache',
    })

    //USE-EFFECTS:
    useEffect(() => { 
        if (!data.loading) {
            if (data.error)
                return toastSweetAlert({
                    mode: 'error',
                    message: data.error.message,
                })

            let list = []
            data.data.getAllGroupsCategories?.rows.map((item) => {
                return list.push({
                    id: item.id,
                    nombre: item.name,
                    grupo: item.GroupOfGroupsCategory.name,
                    icono: <img src={item?.GroupCategoryIconFile?.url ? item?.GroupCategoryIconFile?.url : item.icon} alt="icon" width="30px" height="30px" />,
                    
                })
            })
            setDataToTable(list)
            setTotal(data.data.getAllGroupsCategories?.count)
        }
        
    }, [data])

    //FUNCTIONS:
    const handleDelete = async (id) => {
        
        try {

            const response = await toastSweetAlert({
                mode: 'modalConfirmCancel',
                title: 'Eliminar registro',
                message: `¿Desea continuar?`,
            })
            
            if (response.isConfirmed) {
                showLoading()
                
                const result = await deleteItem({
                    variables: {
                        deleteItemId: parseInt(id),
                    }
                })
        
                if (result) {
                    
                    await data?.refetch({
                        variables: {
                            limit: pagePagination.limit,
                            offset: pagePagination.offset,
                            searchQuery: pagePagination.searchQuery,
                        },
                    })
                    
                    toastSweetAlert({
                        mode: 'ok',
                        message: `Grupo de Reportes ${id} eliminado correctamente`,
                    })
                }
            }
                        

        } catch (error) {
            return toastSweetAlert({
                mode: 'error',
                message: error.message,
            })

        } finally { 
            hideLoading()
        }
    }

    return (
        <>
            <ContentHeader
                title="Gestor de Categorías de Reportes"
                breadcrumb=""
                windowTitle="Categorías de Reportes"
            />

            <LayoutTable                
                title={"Grupos de Reportes"}
                hideDetails                
                hideId
                data={dataTable}
                actionBtnErase={ (e) => handleDelete(e)}
                setPagePagination={setPagePagination}
                pagePagination={pagePagination}
                totalCount={total}
            />
        </>
    )
}
export default ReportCategories